import { render } from "./PlusSidebar.vue?vue&type=template&id=effba91e"
import script from "./PlusSidebar.vue?vue&type=script&lang=js"
export * from "./PlusSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__